import { i18n } from '@/i18n';

export const BiToolsRoute = {
  BITOOLS: 'bitools',
  BITOOLS_CONFIG: 'bitoolsconfig',
};

export const BiToolsPathName = {
  BITOOLS: 'bitools',
};

export const BiTool = {
  POWER_BI: i18n.$t('Power BI'),
  TABLEAU: i18n.$t('Tableau (Coming soon)'),
  METABASE: i18n.$t('Metabase (Coming soon)'),
  TAP_CLICKS: i18n.$t('TapClicks'),
};
